module.exports = __webpack_public_path__ + "68c7a372de7b797b6b0b939f3005839e.svg";